'use client'

import {
  Box,
  Grid2 as Grid,
  Typography,
  useTheme,
} from '@mui/material'
import { Anchor } from '@biolumina/ui/components/anchor/anchor'
import { usePageData } from '@biolumina/ui/hooks/pageData.hook'
import { BaseImage } from '@biolumina/ui/components/baseImage/baseImage'
import { useScrollWidth } from '@biolumina/ui/hooks/scrollWidth.hook'
import { StyledSupport } from './page.styles'
import { SupportItem } from './SupportItem'
import { Nuvationconnect } from './Nuvationconnect'
import { Break } from '@biolumina/ui/components/break/break'
import { PageDivider } from '@biolumina/ui/components/pageDivider/pageDivider'

export default function Support() {
  const { anchors } = usePageData()
  const theme = useTheme()
  const scrollWidth = useScrollWidth()

  return (
    <StyledSupport>
      <Anchor id={anchors[0]}>
        <Typography variant="h2" color="quaternary.main">
          <BaseImage
            width="100%"
            sx={{ maxWidth: '300px' }}
            src="/images/support/logo-nuvation-connect.svg"
            alt="NuvationConnect™ logo"
          />
        </Typography>

        <Typography
          fontSize="1.875rem"
          className="jakarta"
          color="primary.main"
          mb={{ xs: 2, md: 1 }}
          lineHeight={1}
        >
          Connection throughout your treatment journey
        </Typography>
	  <Typography className="body1">
	  NuvationConnect is a comprehensive support program to help you navigate the treatment journey with IBTROZI<sup>&reg;</sup>&nbsp;(taletrectinib).
	  </Typography>
        <Box
          my={4}
          sx={{
            width: `calc(100vw - ${scrollWidth}px)`,
            transform: 'translateX(-50%)',
            left: '50%',
            position: 'relative',
            height: theme.spacing(1.5),
            backgroundImage: `linear-gradient(to right, #B6BDE0 0%, #C5E6E0 52%)`,
          }}
        />

        <Grid container spacing={3} className="support-items" mb={7} mt={7}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              textAlign="center"
              fontSize="45px"
              lineHeight="55px"
              color="#0A404A"
              mb={4}
            >
              How we
              <Break xs={false} md={true} />
              can help*
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <SupportItem
              iconPath="/images/support/icon-personalized-support.svg"
              iconAlt=""
              title={
                <>
                  <span>Personalized</span><Break xs={false} md={true} />
                  <span>Support</span>
                </>
              }
              description="Personalized support to help you understand your insurance coverage and financial options"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <SupportItem
              iconPath="/images/support/icon-one-on-one-support.svg"
              iconAlt=""
              title={
                <>
                  <span>One-on-one</span><Break xs={false} md={true} />
                  <span>Support</span>
                </>
              }
              description="One-on-one help from a Nurse Case Manager who can support you during your IBTROZI journey"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <SupportItem
              iconPath="/images/support/icon-free-trial-offer.svg"
              iconAlt=""
              title={
                <>
                  <span>Free Trial</span><Break xs={false} md={true} />
                  <span>Offer</span>
                </>
              }
              description="Free 30-day supply of IBTROZI with a prescription to determine if treatment is right for you"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <SupportItem
              iconPath="/images/support/icon-quick-start-program.svg"
              iconAlt=""
              title={
                <>
                  <span>Quick Start</span><Break xs={false} md={true} />
                  <span>Program</span>
                </>
              }
              description="Quick Start to get you started on IBTROZI if you experience coverage delays"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <SupportItem
              iconPath="/images/support/icon-copay-assistance.svg"
              iconAlt=""
              title={
                <>
                  <span>Copay</span><Break xs={false} md={true} />
                  <span>Assistance</span>
                </>
              }
              description="Eligible commercially insured patients may pay as little as $0 per month for IBTROZI"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <SupportItem
											  
              iconPath="/images/support/icon-bridge-program.svg"
              iconAlt=""
              title={
                <>
                  <span>Bridge</span><Break xs={false} md={true} />
                  <span>Program</span>
                </>
              }
              description="Helps you stay on IBTROZI if you experience a change in insurance coverage"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <SupportItem
              iconPath="/images/support/icon-patient-assistance-program.svg"
              iconAlt=""
              title={
                <>
                  <span>Patient Assistance</span><Break xs={false} md={true} />
                  <span>Program (PAP)</span>
                </>
              }
              description="PAP may provide IBTROZI at no cost if you have inadequate insurance coverage or are uninsured"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <SupportItem
              iconPath="/images/support/icon-community-resources.svg"
              iconAlt=""
              title={
                <>
                  <span>Community</span><Break xs={false} md={true} />
                  <span>Resources</span>
                </>
              }
              description="Connection to available community and educational resources"
            />
          </Grid>
<Typography className="body1">*Terms, conditions, and eligibility criteria apply.</Typography>
        </Grid>

		


        <Typography
          variant="h3"
          color="primary.main"
          justifyContent="center"
          display="flex"
          sx={{ fontWeight: 'normal',  mb: { xs: 5, md: 2 }  }}
        >
          <Box component="span" sx={{ fontWeight: 'bold', mr: 1 }}>
            Questions?
          </Box>
          We're here to help.
        </Typography>
        <Nuvationconnect />
      </Anchor>

			   <PageDivider progress="50%" />
			  <br/>
      <Anchor id={anchors[1]}>
        <Typography variant="h2">Help from your specialty pharmacy</Typography>
        <Typography variant="body1">
          IBTROZI is available through certain specialty pharmacies who can
          deliver the medication to you by mail. Make sure you discuss your
          options with your doctor.
        </Typography>
      </Anchor>
    </StyledSupport>
  )
}
